// eslint-disable-next-line import/no-anonymous-default-export
export default {
  SET_GEOLOCATION: "SET_GEOLOCATION",
  CLEAR_GEOLOCATION: "CLEAR_GEOLOCATION",
};
